import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import PropTypes from 'prop-types';
import { historyOrReload } from 'utils/helpers';
import { useCurrentBookingState } from 'utils/hooks/use_current_booking_state';
import Modal from 'components/modal_wrapper';
import { discardBooking } from 'redux/actions/booking';
import { getCurrentBooking } from 'redux/selectors/current_booking';

const ContinueEditing = ({ reload = false }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const currentBooking = useSelector(getCurrentBooking);
  const { isEditing, isDraft, canEditReturnOnly } = useCurrentBookingState();

  const onEditMyBooking = () => {
    const qtApiPrefix = window.ecom?.craftConfig?.api_prefix || '';
    const fromOtherPage =
      document.referrer &&
      !document.referrer.includes(`${qtApiPrefix}/bookings`);
    let goBackUrl = `/bookings/${currentBooking.id}`;

    if (isDraft) {
      goBackUrl = `/bookings/${currentBooking.id}/ferry`;

      if (canEditReturnOnly) {
        goBackUrl = `/bookings/${currentBooking.id}/ferry/services/return`;
      }
    }

    if (history && history.length > 1 && !reload) {
      // If previous page is other page than booking flow page, redirect to edit booking page instead of previous page.
      if (fromOtherPage) {
        historyOrReload(history, goBackUrl, true);
      } else {
        history.goBack();
      }
    } else {
      historyOrReload(history, goBackUrl, reload);
    }
  };

  const onStartNewBooking = () => {
    dispatch(discardBooking({ clearFerryGrouping: true })).then(() => {
      historyOrReload(history, '/bookings/', reload);
    });
  };

  const onCheckout = () => {
    historyOrReload(history, '/bookings/checkout', reload);
  };

  return (
    <Modal
      id="continue-editing"
      show={isEditing || isDraft}
      backdropClassName="cover-off-canvas"
      centered
    >
      <Modal.Header>
        <Modal.Title>You&apos;re currently editing a booking</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          You&apos;re current editing booking{' '}
          <strong>{currentBooking.reference}</strong>.
          <br />
          How do you want to proceed?
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex flex-column gap-2 w-100">
          <Button onClick={onEditMyBooking}>
            Return to editing my booking
          </Button>
          {!isDraft && (
            <Button variant="outline-primary" onClick={onCheckout}>
              Go to checkout
            </Button>
          )}
          <Button variant="outline-danger" onClick={onStartNewBooking}>
            Exit and start a new booking
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

ContinueEditing.propTypes = {
  reload: PropTypes.bool,
};

export default ContinueEditing;
